import script from "./SaleSection7.vue?vue&type=script&setup=true&lang=js"
export * from "./SaleSection7.vue?vue&type=script&setup=true&lang=js"

import "./SaleSection7.vue?vue&type=style&index=0&id=2c063eb1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c063eb1"]])

export default __exports__